import Logo from "@/components/Logo";
import { scrollToId } from "@/lib/scroll";
import { EMAIL } from "@/lib/site";

export default function Footer() {
  return (
    <footer className="border-t border-white/10">
      <div className="mx-auto flex max-w-7xl flex-col gap-6 px-6 py-12 lg:flex-row lg:items-center lg:justify-between lg:px-10">
        <button
          data-testid="footer-logo"
          onClick={() => scrollToId("top")}
          className="flex items-center gap-3 self-start"
          aria-label="Back to top"
        >
          <Logo className="h-5 w-5 text-white" />
          <span className="font-display text-sm font-bold tracking-tight text-white">A. Falkenberg</span>
          <span className="font-mono text-[10px] text-fog">{EMAIL}</span>
        </button>
        <p data-testid="footer-legal" className="font-mono text-[10px] tracking-[0.2em] text-fog">
          © {new Date().getFullYear()} DR FALKENBERG TECHNOLOGY CONSULTING INC.
        </p>
        <p className="font-mono text-[10px] tracking-[0.2em] text-fog">LLVM // MLIR // AI SILICON</p>
      </div>
    </footer>
  );
}
